import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { setLoading } from "./LoadingSlice";
import BaseUrl from "../../BaseUrl";
const authurl=BaseUrl.authurl
export const GetExistingUser = createAsyncThunk(
  "login/GetExistingUser",
  async ({ username, userType }, {dispatch, rejectWithValue }) => {
    
    try {
      dispatch(setLoading(true))
      const response = await axios.get(authurl+`Auth/CheckExistingUser?UserName=${username}&UserType=${userType}`);
      console.log(response.data)
      return response.data;
    } catch (error) {
      console.log(error)
      return rejectWithValue(error.response?.data || error.message);
    }finally{
        dispatch(setLoading(false))
    }
  }
);

const loginSlice = createSlice({
  name: "login",
  initialState: {
    username: "",
    userType: "",
    countryCode: "",
    error: null,
    isLoading:false,
    name:'',
    UserNameType: "",
    setpin:'',
    Token:null,
    email:'',
    phoneNumber:'',
    Id:''
  },
  reducers: {
    setUsername: (state, action) => {
      state.username = action.payload;
    },
    setUserType: (state, action) => {
      state.userType = action.payload;
    },
    setCountryCode: (state, action) => {
      state.countryCode = action.payload;
    },
    setName: (state, action) => {
        state.name = action.payload;
    },
    setUserDetails: (state, action) => {
        const { username, userType, countryCode ,name,UserNameType,setpin,email,phoneNumber,Id } = action.payload;
        state.username = username;
        state.userType = userType;
        state.countryCode = countryCode;
        state.name=name,
        state.setpin=setpin,
        state.UserNameType = UserNameType || state.UserNameType; 
        state.email=email;
        state.phoneNumber=phoneNumber,
        state.Id=Id

      },
      setToken:(state,action)=>{
        state.Token=action.payload;
      },
      setId: (state, action) => {
        state.Id = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetExistingUser.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(GetExistingUser.fulfilled, (state, action) => {
        state.isLoading = false;
        const { IsNewUser, Name, UserNameType } = action.payload;

        if (IsNewUser) {
          state.username = action.meta.arg.username;
          state.userType = action.meta.arg.userType;
          state.countryCode = action.meta.arg.countryCode;
        } else {
          // Handle existing user logic here
          state.error = "User already exists.";
        }
      })
      .addCase(GetExistingUser.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || "Something went wrong.";
      });
  },
});

export const { setUsername,setId,setUserType, setCountryCode,setName,setUserDetails } = loginSlice.actions;
export default loginSlice.reducer;
